export enum LoaderMutationTypes {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
  NAVIGATION_SHOW = 'NAVIGATION_SHOW',
  NAVIGATION_HIDE = 'NAVIGATION_HIDE',
  PENDING = 'PENDING',
  DONE = 'DONE'
}
